import { render } from "./ElectronicProtection.vue?vue&type=template&id=4506f8a8"
import script from "./ElectronicProtection.vue?vue&type=script&lang=js"
export * from "./ElectronicProtection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__